export default {
  message: {
    "strid1": "Homepage",
    "strid2": "Tutorial",
    "strid3": "Event",
    "strid4": "Join Us",
    "strid5": "Discord",
    "strid6": "Creator Academy",
    "strid7": "Selected Works",
    "strid8": "Back",
    "strid9": "Participate Now",
    "strid10": "More Events",
    "strid11": "Personal Info",
    "strid12": "Game Server",
    "strid13": "Please enter your Server",
    "strid14": "Game ID",
    "strid15": "Please enter your game ID",
    "strid16": "Contact Info",
    "strid17": "Select Platform",
    "strid18": "Please enter your contact info",
    "strid19": "Work Details",
    "strid20": "Publishing Platform",
    "strid21": "Please enter a correct link",
    "strid22": "Tap to add a new link",
    "strid23": "Language Used",
    "strid24": "Select language used",
    "strid25": "English",
    "strid26": "Arabic",
    "strid27": "Spanish",
    "strid28": "Portuguese",
    "strid29": "Khmer",
    "strid30": "Burmese",
    "strid31": "Malay",
    "strid32": "Other",
    "strid33": "I confirm the ownership of the work and acknowledge this agreement",
    "strid34": "Submit",
    "strid35": "Submitted!",
    "strid36": "Perks",
    "strid37": "Join us now to get",
    "strid38": "Support from MLBB official social media",
    "strid39": "Creator interactive community",
    "strid40": "Weekly Diamond reward",
    "strid41": "More perks to unlock",
    "strid42": "Game Merchandise",
    "strid43": "Offline events",
    "strid44": "Tons of skins",
    "strid45": "Brand collaboration",
    "strid46": "Ad promotion",
    "strid47": "JOIN US",
    "strid48": "Requirements",
    "strid49": "FOLLOW US",
    "strid50": "Tap to check MLBB official account",
    "strid51": "Agreement Content",
    "strid52": "Please complete the information",
    "strid53": "Submission failed",
    "strid54": "Please fill in the link of your channel",  // 请输入正确的频道链接
    "strid55": "Select your region",
    "strid56": "Your Region",

  }
}
